// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"loading-spinner_loadingSpinner__mT626","icon":"loading-spinner_icon__Uc2T7","spin":"loading-spinner_spin__IhMJD"};